// Utilitarios de data no fuso LOCAL do navegador.
//
// Motivo: `new Date().toISOString().split("T")[0]` converte para UTC antes de
// cortar a string. No Brasil (UTC-3) qualquer horario a partir das 21:00 ja
// cai no dia seguinte em UTC, entao a tela abria com a data errada.

/**
 * Formata um Date como YYYY-MM-DD usando os componentes de data LOCAIS.
 * @param {Date} [date=new Date()]
 * @returns {string} data no formato YYYY-MM-DD
 */
export function toLocalISODate(date = new Date()) {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, "0");
	const d = String(date.getDate()).padStart(2, "0");
	return `${y}-${m}-${d}`;
}

/**
 * Data de hoje no fuso local, no formato YYYY-MM-DD.
 * @returns {string}
 */
export function hojeISO() {
	return toLocalISODate(new Date());
}
